import { BRAND } from '../../config/brand';
import './Legal.css';

function LegalRefunds() {
  return (
    <main className="legal-page">
      <div className="container">
        <div className="legal-card">
          <h1 className="legal-title">Refund Policy</h1>
          <div className="legal-meta">
            Last updated: {BRAND.legal.lastUpdated} • {BRAND.legal.companyName}
          </div>

          <div className="legal-content">
            <p>
              We aim to be fair and fast with refunds. This policy describes when you can request a refund for a domain order.
            </p>

            <h2>1) If the Domain Cannot Be Registered</h2>
            <p>
              If the domain becomes unavailable after you pay (or cannot be registered for reasons outside our control), you may
              choose either:
            </p>
            <ul>
              <li>A refund to your original payment method, or</li>
              <li>A switch to an alternative domain we suggest (if you approve).</li>
            </ul>

            <h2>2) Service Already Delivered</h2>
            <p>
              If the domain is successfully registered and transferred into your control (or otherwise delivered as agreed), the
              domain registration fee may be non-refundable depending on registrar rules.
            </p>

            <h2>3) How to Request a Refund</h2>
            <p>
              Email <a className="legal-link" href={`mailto:${BRAND.legal.contactEmail}`}>{BRAND.legal.contactEmail}</a> with your
              order ID and the domain name.
            </p>

            <h2>4) Processing Time</h2>
            <p>
              Approved refunds are typically initiated within a few business days. Final timing depends on PayPal and your bank.
            </p>

            <h2>5) Contact</h2>
            <p>
              Questions about refunds? Reach us at{' '}
              <a className="legal-link" href={`mailto:${BRAND.legal.contactEmail}`}>{BRAND.legal.contactEmail}</a>
              {' '}or via WhatsApp at{' '}
              <a className="legal-link" href={BRAND.legal.whatsapp} target="_blank" rel="noopener noreferrer">WhatsApp</a>.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default LegalRefunds;
